import { Injectable, Pipe } from '@angular/core';

/*
  Generated class for the HasProperty pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
  name: 'hasProperty'
})

@Injectable()

export class HasPropertyPipe {
  /*
    Takes a value and makes it lowercase.
   */
  transform(values, args) {

    let property = args.split(',')[0];

    values = values.filter(value => {
      return !!value[property]
    });

    return values;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/has-property.ts